import { Injectable } from '@angular/core';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import{Ba1380Class}from '../../Class/ba1380/ba1380-class'
import {environment} from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class ba1380Service {

  baseUrl: string=environment.baseUrl + 'ba1380/';
  constructor(private http:HttpClient) { }


GetCommonControlNames(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetCommonControlNames/'+id);
}

GetControlNames():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetControlNames');
}

//Load saved data in to find section
LoadFind():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadFind');
}

//Select an entry from find section
DoFind(Ba1380Class:Ba1380Class):Observable<any>
{
  return this.http.post<any>(this.baseUrl+'doFind',Ba1380Class);
}


//Add or Edit an entry
Create(religion_class:Ba1380Class): Observable<any>
{
  return this.http.post<any>(this.baseUrl+'Create',religion_class);
}

//Delete an entry
Delete(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'Delete/'+id);
}

}
